import { useContext } from 'react';
import { AuthContext } from '../contexts/Auth/Auth';

export default function useAuth() {
  const auth = useContext(AuthContext);

  return auth;
}
